import { COLOR, line, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'TRIMA',
  version: 1,
  label: 'Triangular Moving Average',
  pane: 'main',
  category: 'trend',
  series: 'price',
  order: 34,
  inputs: [period('timeperiod', 30)],
  outputs: [line('trima', 'TRIMA', COLOR.blue)],
  talib: { functions: ['TRIMA'], expr: 'TRIMA(close, timeperiod={timeperiod})' },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod }) => timeperiod - 1,
}
export default def
